import { z } from 'zod';

const DirectDebitMandateStatuses = {
  NOT_SET: 'NOT_SET',
  IN_PROGRESS: 'IN_PROGRESS',
  SET: 'SET',
} as const;

const directDebitMandateStatusSchema = z.enum(DirectDebitMandateStatuses);

export const bankAccountResponseBaseSchema = z.object({
  directBank: z.boolean(),
  accountNumber: z.string(),
  bankName: z.string(),
  directDebitMandateStatus: directDebitMandateStatusSchema,
});

export const noBankAccountResponseSchema = z.object({
  accountNumber: z.null(),
  bankName: z.null(),
  clearingNumber: z.null(),
  directBank: z.literal(false),
  directDebitMandateStatus: z.literal(DirectDebitMandateStatuses.NOT_SET),
});

export const zimplerResponseSchema = bankAccountResponseBaseSchema.extend({
  clearingNumber: z.string(),
});

const trustlyResponseSchema = bankAccountResponseBaseSchema.extend({
  clearingNumber: z.null(),
});

export const bankAccountResponseSchema = z.union([
  noBankAccountResponseSchema,
  zimplerResponseSchema,
  trustlyResponseSchema,
]);
